import { useState } from "react";
import NormiesBlackjack from "./Blackjack";
import Tetris from "./Tetris";

var DARK = "#48494b";
var LIGHT = "#e3e5e4";

export default function App() {
  var s = useState("blackjack");
  var tab = s[0], setTab = s[1];

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0c", color: LIGHT, fontFamily: "'IBM Plex Mono',monospace" }}>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <nav style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 16px", height: 56, background: "#0c0c0e",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        position: "sticky", top: 0, zIndex: 100,
      }}>
        <a href="https://www.normies.art" target="_blank" rel="noreferrer"
          style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", color: LIGHT }}>
          <div style={{ display: "flex", gap: 2 }}>
            <div style={{ width: 8, height: 8, background: DARK, borderRadius: 1 }} />
            <div style={{ width: 8, height: 8, background: LIGHT, borderRadius: 1 }} />
          </div>
          <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: "0.04em" }}>NORMIE GAMES</span>
        </a>
        <div style={{ display: "flex", gap: 4 }}>
          <button onClick={function() { setTab("blackjack"); }}
            style={{
              padding: "8px 16px", borderRadius: 8,
              border: tab === "blackjack" ? "1.5px solid rgba(227,229,228,0.3)" : "1.5px solid transparent",
              background: tab === "blackjack" ? "rgba(227,229,228,0.08)" : "transparent",
              color: tab === "blackjack" ? LIGHT : "#666",
              fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
            }}>
            {"\u2660"} BlackJack
          </button>
          <button onClick={function() { setTab("tetris"); }}
            style={{
              padding: "8px 16px", borderRadius: 8,
              border: tab === "tetris" ? "1.5px solid rgba(227,229,228,0.3)" : "1.5px solid transparent",
              background: tab === "tetris" ? "rgba(227,229,228,0.08)" : "transparent",
              color: tab === "tetris" ? LIGHT : "#666",
              fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
            }}>
            {"\u25A6"} Tetris
          </button>
        </div>
        <a href="https://www.normies.art" target="_blank" rel="noreferrer"
          style={{ fontSize: 10, color: "#555", textDecoration: "none", letterSpacing: "0.08em", textTransform: "uppercase" }}>
          normies.art {"\u2197"}
        </a>
      </nav>
      <div style={{ display: tab === "blackjack" ? "block" : "none" }}>
        <NormiesBlackjack />
      </div>
      <div style={{ display: tab === "tetris" ? "block" : "none" }}>
        <Tetris />
      </div>
    </div>
  );
}
